"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collection = Collection;
exports.removeItemInternalProps = removeItemInternalProps;

var _react = _interopRequireDefault(require("react"));

var _collection = require("../collection");

var _context = require("./context");

var _useItem2 = require("./useItem");

var _excluded = ["as", "children", "items"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var exclude = new Set(['index', 'indexes', 'itemRef', 'key', 'parentItemRef', 'prevKey', 'nextKey']);

var ItemContainer = function ItemContainer(_ref) {
  var _ref$item = _ref.item,
      item = _ref$item === void 0 ? {} : _ref$item,
      index = _ref.index,
      keyValue = _ref.keyValue,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_useItem2.ItemContextProvider, {
    value: _objectSpread(_objectSpread({}, item), {}, {
      index: index,
      key: keyValue
    })
  }, children);
};

function Collection(_ref2) {
  var as = _ref2.as,
      children = _ref2.children,
      items = _ref2.items,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  var api = (0, _context.useAPI)();

  var _useItem = (0, _useItem2.useItem)(),
      parentKey = _useItem.key;

  return /*#__PURE__*/_react.default.createElement(_collection.Collection, _extends({}, otherProps, {
    as: as,
    exclude: exclude,
    itemContainer: ItemContainer,
    items: items,
    parentKey: parentKey,
    publicApi: api
  }), children);
}

function removeItemInternalProps(props) {
  return (0, _collection.excludeProps)(props, exclude);
}